import { createSlice } from '@reduxjs/toolkit';

const initialState = { siteTypes: [] };   // <- correct prop name

const siteTypesSlice = createSlice({
  name: 'siteTypes',
  initialState,
  reducers: {
    setSiteTypes(state, action) {
      state.siteTypes = action.payload;
    },
    clearSiteTypes(state) {
      state.siteTypes = [];
    },
  },
});

export const { setSiteTypes, clearSiteTypes } = siteTypesSlice.actions;

/** Root selector */
export const selectSiteTypes = (state) => state.siteTypes.siteTypes;

export default siteTypesSlice.reducer;
